export const ValidatePhone = (phone) => {
  const regex = /^\+\d{11}$/;
  return regex.test(phone);
  };